import { render } from "./MyDropdownContainer.vue?vue&type=template&id=120de354&scoped=true"
import script from "./MyDropdownContainer.vue?vue&type=script&lang=js"
export * from "./MyDropdownContainer.vue?vue&type=script&lang=js"

import "./MyDropdownContainer.vue?vue&type=style&index=0&id=120de354&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-120de354"]])

export default __exports__